import type { Preset } from '@primeuix/themes/types'

export default {
    primitive: {
        red: {
            50: 'var(--bp-action-red-50)',
            100: 'var(--bp-action-red-100)',
            200: 'var(--bp-action-red-200)',
            300: 'var(--bp-action-red-300)',
            400: 'var(--bp-action-red-400)',
            500: 'var(--bp-danger)',
            600: 'var(--bp-action-red-800)',
            700: 'var(--bp-action-red-900)',
            800: 'var(--bp-action-red-950)',
            900: 'var(--bp-action-red-950)',
            950: 'var(--bp-action-red-950)',
        },
    },
    semantic: {
        primary: {
            50: 'var(--bp-primary-50)',
            100: 'var(--bp-primary-100)',
            200: 'var(--bp-primary-200)',
            300: 'var(--bp-primary-300)',
            400: 'var(--bp-primary-400)',
            500: 'var(--bp-primary-500)',
            600: 'var(--bp-primary-600)',
            700: 'var(--bp-primary-700)',
            800: 'var(--bp-primary-800)',
            900: 'var(--bp-primary-900)',
            950: 'var(--bp-primary-950)',
        },
        colorScheme: {
            light: {
                surface: {
                    0: '#ffffff',
                    50: 'var(--bp-surface-50)',
                    100: 'var(--bp-surface-100)',
                    200: 'var(--bp-surface-200)',
                    300: 'var(--bp-surface-300)',
                    400: 'var(--bp-surface-400)',
                    500: 'var(--bp-surface-500)',
                    600: 'var(--bp-surface-600)',
                    700: 'var(--bp-surface-700)',
                    800: 'var(--bp-surface-800)',
                    900: 'var(--bp-surface-900)',
                    950: 'var(--bp-surface-950)',
                },
                formField: {
                    invalidBorderColor: 'var(--bp-danger)',
                    invalidPlaceholderColor: 'var(--bp-danger)',
                    floatLabelInvalidColor: 'var(--bp-danger)',
                },
                'text-default': 'var(--bp-text-color)',
                'text-neutral-600': 'var(--bp-text-neutral-600-color)',
                'text-on-primary': 'white',

                info: 'var(--bp-blue-400)',
                'info-500': 'var(--bp-blue-500)',
            },
            dark: {},
        },
        danger: 'var(--bp-danger)',
        'text-link': 'var(--bp-blue-400)',
        'text-link-hover': 'var(--bp-blue-200)',
        radius: {
            xs: 'var(--bp-border-radius-rounded-none)',
            sm: 'var(--bp-border-radius-rounded-sm)',
            md: 'var(--bp-border-radius-rounded-md)',
            lg: 'var(--bp-border-radius-rounded-lg)',
            xl: 'var(--bp-border-radius-rounded-xl)',
            '2xl': 'var(--bp-border-radius-rounded-2xl)',
            full: 'var(--bp-border-radius-rounded-full)',
        },
        formField: {
            padding: {
                x: 'var(--bp-spacing-3)',
                y: 'var(--bp-spacing-2)',
            },
            font: {
                size: '14px',
            },

            border: {
                radius: 'var(--bp-border-radius-rounded-lg)',
            },
            sm: {
                padding: {
                    x: 'var(--bp-spacing-3)',
                    y: 'var(--bp-spacing-2)',
                },

                font: {
                    size: '14px',
                },

                border: {
                    radius: 'var(--bp-border-radius-rounded-lg)',
                },
            },
            lg: {
                padding: {
                    x: 'var(--bp-spacing-4)',
                    y: 'var(--bp-spacing-3)',
                },
                font: {
                    size: '16px',
                },
                border: {
                    radius: 'var(--bp-border-radius-rounded-lg)',
                },
            },
        },
    },
    components: {
        tag: {
            colorScheme: {
                light: {
                    primary: {
                        background: 'var(--bp-primary-100)',
                        color: 'var(--bp-primary-700)',
                    },
                    secondary: {
                        background: 'var(--bp-surface-200)',
                        color: 'var(--bp-surface-600)',
                    },
                    success: {
                        background: 'var(--bp-action-pine-100)',
                        color: 'var(--bp-action-pine-800)',
                    },
                    info: {
                        background: 'var(--bp-action-blue-100)',
                        color: 'var(--bp-action-blue-700)',
                    },
                    warn: {
                        background: 'var(--bp-action-orange-100)',
                        color: 'var(--bp-action-orange-800)',
                    },
                    danger: {
                        background: 'var(--bp-action-red-100)',
                        color: 'var(--bp-action-red-800)',
                    },
                    contrast: {
                        background: 'var(--bp-surface-950)',
                        color: 'var(--bp-surface-0)',
                    },
                },
            },
        },
        toast: {
            colorScheme: {
                light: {
                    info: {
                        background: 'var(--bp-action-blue-100)',
                        color: 'var(--bp-action-blue-700)',
                        detailColor: 'var(--bp-action-blue-700)',
                    },
                    success: {
                        background: 'var(--bp-action-pine-100)',
                        color: 'var(--bp-action-pine-800)',
                        detailColor: 'var(--bp-action-pine-800)',
                    },
                    warn: {
                        background: 'var(--bp-action-orange-100)',
                        borderColor: 'var(--bp-action-orange-100)',
                        color: 'var(--bp-action-orange-800)',
                        detailColor: 'var(--bp-action-orange-800)',
                    },
                    error: {
                        background: 'var(--bp-action-red-100)',
                        color: 'var(--bp-action-red-800)',
                        detailColor: 'var(--bp-action-red-800)',
                    },
                    secondary: {
                        background: 'var(--bp-surface-200)',
                        color: 'var(--bp-surface-600)',
                        detailColor: 'var(--bp-surface-600)',
                    },
                },
            },
        },
        message: {
            colorScheme: {
                light: {
                    info: {
                        background: 'var(--bp-action-blue-100)',
                        borderColor: 'var(--bp-action-blue-100)',
                        color: 'var(--bp-action-blue-700)',
                        closeButton: {
                            hoverBackground: 'var(--bp-action-blue-100)',
                            focusRing: { color: 'var(--bp-action-blue-700)' },
                        },
                        outlined: {
                            color: 'var(--bp-action-blue-700)',
                            borderColor: 'var(--bp-action-blue-700)',
                        },
                        simple: { color: 'var(--bp-action-blue-700)' },
                    },
                    success: {
                        background: 'var(--bp-action-pine-100)',
                        borderColor: 'var(--bp-action-pine-100)',
                        color: 'var(--bp-action-pine-800)',
                        closeButton: {
                            hoverBackground: 'var(--bp-action-pine-100)',
                            focusRing: { color: 'var(--bp-action-pine-800)' },
                        },
                        outlined: {
                            color: 'var(--bp-action-pine-800)',
                            borderColor: 'var(--bp-action-pine-800)',
                        },
                        simple: { color: 'var(--bp-action-pine-800)' },
                    },
                    warn: {
                        background: 'var(--bp-action-orange-100)',
                        borderColor: 'var(--bp-action-orange-100)',
                        color: 'var(--bp-action-orange-800)',
                        closeButton: {
                            hoverBackground: 'var(--bp-action-orange-100)',
                            focusRing: { color: 'var(--bp-action-orange-800)' },
                        },
                        outlined: {
                            color: 'var(--bp-action-orange-800)',
                            borderColor: 'var(--bp-action-orange-800)',
                        },
                        simple: { color: 'var(--bp-action-orange-800)' },
                    },
                    error: {
                        background: 'var(--bp-action-red-100)',
                        borderColor: 'var(--bp-action-red-100)',
                        color: 'var(--bp-action-red-800)',
                        closeButton: {
                            hoverBackground: 'var(--bp-action-red-100)',
                            focusRing: { color: 'var(--bp-action-red-800)' },
                        },
                        outlined: {
                            color: 'var(--bp-action-red-800)',
                            borderColor: 'var(--bp-action-red-800)',
                        },
                        simple: { color: 'var(--bp-action-red-800)' },
                    },
                    secondary: {
                        background: 'var(--bp-surface-200)',
                        borderColor: 'var(--bp-surface-200)',
                        color: 'var(--bp-surface-600)',
                        closeButton: {
                            hoverBackground: 'var(--bp-surface-200)',
                            focusRing: { color: 'var(--bp-surface-600)' },
                        },
                        outlined: {
                            color: 'var(--bp-surface-600)',
                            borderColor: 'var(--bp-surface-500)',
                        },
                        simple: { color: 'var(--bp-surface-600)' },
                    },
                    contrast: {
                        background: 'var(--bp-surface-950)',
                        borderColor: 'var(--bp-surface-950)',
                        color: 'var(--bp-surface-50)',
                        closeButton: {
                            hoverBackground: 'var(--bp-surface-950)',
                            focusRing: { color: 'var(--bp-surface-50)' },
                        },
                        outlined: {
                            color: 'var(--bp-surface-950)',
                            borderColor: 'var(--bp-surface-950)',
                        },
                        simple: { color: 'var(--bp-surface-950)' },
                    },
                },
            },
        },
        inlinemessage: {
            colorScheme: {
                light: {
                    info: {
                        background: 'var(--bp-action-blue-100)',
                        borderColor: 'var(--bp-action-blue-100)',
                        color: 'var(--bp-action-blue-700)',
                    },
                    success: {
                        background: 'var(--bp-action-pine-100)',
                        borderColor: 'var(--bp-action-pine-100)',
                        color: 'var(--bp-action-pine-800)',
                    },
                    warn: {
                        background: 'var(--bp-action-orange-100)',
                        borderColor: 'var(--bp-action-orange-100)',
                        color: 'var(--bp-action-orange-800)',
                    },
                    error: {
                        background: 'var(--bp-action-red-100)',
                        borderColor: 'var(--bp-action-red-100)',
                        color: 'var(--bp-action-red-800)',
                    },
                    secondary: {
                        background: 'var(--bp-surface-200)',
                        borderColor: 'var(--bp-surface-200)',
                        color: 'var(--bp-surface-600)',
                    },
                    contrast: {
                        background: 'var(--bp-surface-950)',
                        borderColor: 'var(--bp-surface-950)',
                        color: 'var(--bp-surface-50)',
                    },
                },
            },
        },
        chip: {
            colorScheme: {
                light: {
                    background: 'var(--bp-surface-100)',
                    gap: 'var(--bp-spacing-2)',
                    color: 'var(--bp-surface-800)',
                    padding: {
                        x: 'var(--bp-spacing-4)',
                        y: 'var(--bp-spacing-2)',
                    },
                    border: { radius: 'var(--bp-border-radius-rounded-full)' },
                },
            },
        },
        button: {
            colorScheme: {
                light: {
                    gap: 'var(--bp-spacing-2)',
                    icon: {
                        only: {
                            width: '40px',
                        },
                    },
                    sm: {
                        padding: {
                            x: 'var(--bp-spacing-3)',
                            y: 'var(--bp-spacing-1)',
                        },
                        icon: {
                            only: {
                                width: '39px', // This comes from the computed height in the browser. Keep this matched
                            },
                        },
                    },
                    padding: {
                        x: 'var(--bp-spacing-4)',
                        y: 'var(--bp-spacing-2)',
                    },
                    info: {
                        background: 'var(--bp-action-blue-600)',
                        hoverBackground: 'var(--bp-action-blue-700)',
                        activeBackground: 'var(--bp-action-blue-800)',
                        borderColor: 'var(--bp-action-blue-600)',
                        hoverBorderColor: 'var(--bp-action-blue-700)',
                        activeBorderColor: 'var(--bp-action-blue-800)',
                    },
                },
            },
        },
        dialog: {
            header: {
                padding: 'var(--bp-spacing-10) var(--bp-spacing-10) 0',
            },
            title: {
                font: {
                    size: '20px',
                    weight: '400',
                },
            },
            content: {
                padding: 'var(--bp-spacing-12) var(--bp-spacing-10) var(--bp-spacing-10)',
            },
        },
        inputtext: {
            root: { paddingX: 'var(--bp-spacing-4)', paddingY: 'var(--bp-spacing-3)' },
        },
        accordion: {
            colorScheme: {
                light: {
                    header: {
                        background: 'transparent',

                        hover: {
                            background: 'transparent',
                        },
                        active: {
                            background: 'transparent',
                            hover: {
                                background: 'transparent',
                            },
                        },
                    },
                    content: {
                        background: 'transparent',
                    },
                },
            },
        },
    },
} as Preset
